const propertyListAPIs = {
    'getListDetails': '/compsList/getListDetails',
    'saveSavedSearch': '/searchCriteria/save',
    // 'deleteCompsListProperty': '/compsList/deleteCompsListProperty',
    'modifyUnitMixSourcePreference': '/compsList/modifyUnitMixSourcePreference',
    'getMessageStatus': '/compsList/getMessageStatus?',
}

export default propertyListAPIs
